


import React from "react";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image } from "antd";
import { useNavigate } from "react-router-dom";
import "../../Styles/login.css";

const ChangePassword = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();

  const handleRedirectLogin = () => {
    navigate('/')
  }
  const onFinish = (values) => {
    setIsLoggedIn(true);
    // navigate("/dashboard");
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      <Col md={12}>
        <div className="forgetPass"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <h3>Reset your Password ?</h3>

          <hr className="my-4" />
          <Form.Item
            name="token"
            label="Token"
            rules={[{ required: true, message: "Please input your Token!" }]}
          >
            <Input className="input_field" placeholder="Token" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[{ required: true, message: "Please input your New Password!" }]}
          >
            <Input className="input_field" placeholder="New Password" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            rules={[{ required: true, message: "Please input your New Password!" }]}
          >
            <Input className="input_field" placeholder="New Password" />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              className="btn_submit"
            >
              Reset
            </Button>
          </Form.Item>
          {/* <Form.Item>
            <Flex justify="center" align="center">
              <p onClick={handleRedirectLogin} style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500' }}>Back to Login</p>
            </Flex>
          </Form.Item> */}
        </Form>
      </Col>
    </Row>
  );
};

export default ChangePassword;
